import type { TrackedTask } from "./tracking/TrackedTask"

export type EventEmitter = (task: TrackedTask) => Promise<void>
